import api from "./api";
import {
  ApiResult,
  CreateExchangeNumerary,
  ExchangeNumeraryPanel,
  UnitProfile,
} from "../models/ExchangeNumerary";

const base = (processId: string) => `/api/process/${processId}/exchange-numerary`;

export const getExchangeNumeraryPanel = async (processId: string): Promise<ExchangeNumeraryPanel> =>
  (await api.get(base(processId))).data;

export const createExchangeNumerary = async (processId: string, command: CreateExchangeNumerary): Promise<ApiResult> =>
  (await api.post(base(processId), command)).data;

export const downloadExchangeNumeraryPdf = async (processId: string, requestId: string, fileName: string) => {
  const response = await api.get(`${base(processId)}/${requestId}/pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  // Revogar na hora pode cancelar o download em alguns navegadores
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const sendExchangeNumerary = async (
  processId: string,
  requestId: string,
  command: { to: string; cc?: string; message?: string },
): Promise<ApiResult> => (await api.post(`${base(processId)}/${requestId}/send`, command)).data;

export const setExchangeNumeraryReceived = async (processId: string, requestId: string, receivedAt: string | null): Promise<ApiResult> =>
  (await api.put(`${base(processId)}/${requestId}/received`, { receivedAt })).data;

export const deleteExchangeNumerary = async (processId: string, requestId: string): Promise<ApiResult> =>
  (await api.delete(`${base(processId)}/${requestId}`)).data;

export const getUnitProfiles = async (): Promise<UnitProfile[]> => (await api.get("/api/unit-profiles")).data;

export const saveUnitProfile = async (unit: UnitProfile): Promise<ApiResult> => (await api.put("/api/unit-profiles", unit)).data;
